window.addEventListener("load",function(){
$(".product_custom_logo_size_shape_select").change(function() {
    let imageObj = [
      {
        "name":"Square",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/LOGO_29d8c49a-02f3-424c-888e-c33a8b6bdf5c.png?v=1731463525",
        "valueList":["1 Inch * 1 Inch","1.2 Inch * 1.2 Inch","1.8 Inch * 1.8 Inch","2 Inch * 2 Inch"]
      },
       {
        "name":"Rectangle",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/7_3_-LOGO.png?v=1731463525",
        "valueList":["2 Inch * 0.6 Inch","2.4 Inch * 0.6 Inch","3.5 Inch * 1.6 Inch","3.5 Inch * 1.2 Inch","3.5 Inch * 1.8 Inch","4 Inch * 1.2 Inch","3.1 Inch* 0.8 Inch","3.9 Inch * 1.4 Inch","3.5 Inch * 1.2 Inch"]
      },
       {
        "name":"Triangle",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/LOGO_e53014d9-b025-4baa-a893-2ee9559b57a5.png?v=1731463525",
        "valueList":["0.78 Inch * 0.78 Inch","1.18 Inch * 1.18 Inch"]
      },
       {
        "name":"Rotundity",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/LOGO_468e4e55-2022-4582-b14f-110a66dd1cba.png?v=1731463525",
        "valueList":["0.8 Inch * 0.8 Inch","1.2 Inch * 1.2 Inch","1.5 Inch * 1.5 Inch"]
      }
    ]
    let val = $(this).val()
    for (let item of imageObj) {
      if (val == item.name) {
        $(this).siblings(".product_custom_logo_size_shape_image").find("img").attr("src",item.image)
        $(".product_custom_logo_size_select").empty()
        $.each(item.valueList, function(index, option) {
           $(".product_custom_logo_size_select").append(new Option(option, option));
        });
      }
    }
  })

    $(".product_custom_logo_radio").click(function() {
    if (!$(this).hasClass("active")) {
      let index = $(this).index()
      $(this).siblings().removeClass("active")
      $(this).addClass("active")
      const totalQuantity = $(".product_custom_total").html() * 1
      const cartBtn = document.querySelector('product-form button[name="add"]')
      if (index == 0) {
        $(".product_custom_logo_content").addClass("active")
        if (totalQuantity >= 4 ) {
          cartBtn.setAttribute('aria-disabled', false);
        }else{
          cartBtn.setAttribute('aria-disabled', true);
        }
      }else{
        $(".product_custom_logo_content").removeClass("active")
        if (totalQuantity > 0 ) {
          cartBtn.setAttribute('aria-disabled', false);
        }else{
          cartBtn.setAttribute('aria-disabled', true);
        }
      }
    }
  })
  // $("input[name='custom_logo_position']").change(function() {
  //    const selectedCount = $("input[name='custom_logo_position']:checked").length;
  //     const total_count = $(".product_custom_total").html() * 1
  //     const logoMaterialPrice =  $('input[name="product_custom_logoMaterial"]:checked').data("price") * 1 * total_count * selectedCount;
  //     $(".product_custom_material_total").html(total_count * selectedCount)
  //     $(".product_custom_total_price").html(`$${(logoMaterialPrice / 100).toFixed(2)}`)
  // })
  //  $("input[name='product_custom_logoMaterial']").change(function() {
  //    const selectedCount = $("input[name='custom_logo_position']:checked").length;
  //     const total_count = $(".product_custom_total").html() * 1
  //     const logoMaterialPrice =  $('input[name="product_custom_logoMaterial"]:checked').data("price") * 1 * total_count * selectedCount;
  //     $(".product_custom_material_total").html(total_count * selectedCount)
  //     $(".product_custom_total_price").html(`$${(logoMaterialPrice / 100).toFixed(2)}`)
  // })


  // $("input[name='custom_logo_position']").change(function() {
  //   const logoNum = getLogoFileValidRows().length || 1;
  //    const selectedCount = $("input[name='custom_logo_position']:checked").length;
  //     const total_count = $(".total-quantity").html() * 1
  //     const logoMaterialPrice =  $('.product_custom_logoMaterial_card.selected').data("price") * 1 * total_count * selectedCount * logoNum;
  //     $(".summary-pl-num").html(total_count * selectedCount * logoNum)
  //     $(".summary-pl-fee").html(`${(logoMaterialPrice / 100).toFixed(2)}`)
  //     // onChangeTotalPrice();
  // })
   




})

const discountList = [
          ["1 - 4","0","No Discount",500],
          ["5 - 50","5","VIP5",500],
          ["51 - 100","10","VIP10",1000],
          ["101 - 249","12","VIP12",2000],
          ["250+","15","VIP15",5000],
        ];


$("input[name='custom_logo_position']").change(function() {
    const logoNum = getLogoFileValidRows().length || 1;
     const selectedCount = $("input[name='custom_logo_position']:checked").length || 1;
      const total_count = $(".total-quantity").html() * 1
      const logoMaterialPrice =  $('.product_custom_logoMaterial_card.selected').data("price") * 1 * total_count * selectedCount * logoNum;
      $(".summary-pl-num").html(total_count * selectedCount * logoNum)
      $(".summary-pl-fee").html(`${(logoMaterialPrice / 100).toFixed(2)}`)
      $(".mobile-summary-pl-num").html(total_count * selectedCount * logoNum)
      $(".mobile-summary-pl-fee").html(`${(logoMaterialPrice / 100).toFixed(2)}`)
      // onChangeTotalPrice();
})      

$(".product_custom_logoMaterial_card").on('click', function() {
    // const selectedCount = $("input[name='custom_logo_position']:checked").length;
    // const total_count = $(".summary-p-num").html() * 1
    // console.log("selectedCount: ",selectedCount)
    // const logoMaterialPrice =  $(this).data("price") * 1 * total_count * selectedCount;
    // $(".summary-pl-num").html(total_count * selectedCount)
    // $(".summary-pl-fee").html(`${(logoMaterialPrice / 100).toFixed(2)}`)
    updatePrintLogoFee();
    // onChangeTotalPrice();
})

function isNeedLogo(){
  const needLogoEle = $('.option-card.selected[data-target="private-label-block"]');
  if(needLogoEle){
    const needLogo = needLogoEle.data("value")?.trim();
    if(needLogo==='yes'){
      return true;
    }else{
      return false;
    }
  }else{
    return false;
  }
  
}


function isFirstLogo(){
  const haveOrder = $('.option-card.selected[data-target="have-order"]').data("value").trim();
    // console.log("haveOrder: ",haveOrder)
    if(haveOrder==='yes'){
      return true;
    }else{
      return false;
    }
}


function getLogoFileValidRows() {
  return Array.from(document.querySelectorAll('.logo-row.body'))
    // .filter(row => row.querySelector('.logoUpload').files.length > 0 )
    .map(row => ({
      path: row.querySelector('.logoUpload').files[0],
      fileName: row.querySelector('.file-name').textContent,
      width   : row.querySelector('.size-cell input:nth-of-type(1)').value,
      height  : row.querySelector('.size-cell input:nth-of-type(2)').value
    }));
}     

function updatePrintLogoFee(){
    const logoNum = getLogoFileValidRows().length || 1;
    const selectedCount = $("input[name='custom_logo_position']:checked").length || 1;
    const total_count = $(".total-quantity").html() * 1
    // console.log("selectedCount: ",selectedCount)
    const logoMaterialPrice =  $(".product_custom_logoMaterial_card.selected").data("price") * 1 * total_count * selectedCount * logoNum;
    $(".summary-pl-num").html(total_count * selectedCount * logoNum)
    $(".summary-pl-fee").html(`${(logoMaterialPrice / 100).toFixed(2)}`)
    $(".mobile-summary-pl-num").html(total_count * selectedCount * logoNum)
    $(".mobile-summary-pl-fee").html(`${(logoMaterialPrice / 100).toFixed(2)}`)
    
}

function updateLogoSetupFee(){
    const haveOrder = isFirstLogo();
 
    if(haveOrder){
      const logoNum = getLogoFileValidRows().length || 1;
      document.querySelector('.summary-logo-setup-num').innerHTML = logoNum
      document.querySelector('.summary-logo-setup-fee').innerHTML = 50 * logoNum
      document.querySelector('.mobile-summary-logo-setup-num').innerHTML = logoNum
      document.querySelector('.mobile-summary-logo-setup-fee').innerHTML = 50 * logoNum
    }else{
      const logoNum = getLogoFileValidRows().length || 1;
      document.querySelector('.summary-logo-setup-num').innerHTML = logoNum
      document.querySelector('.summary-logo-setup-fee').innerHTML = '0.00'
      document.querySelector('.mobile-summary-logo-setup-num').innerHTML = logoNum
      document.querySelector('.mobile-summary-logo-setup-fee').innerHTML = '0.00'
    }
}

function defaultQuantitySetUp(sectionId){
  //  console.log("sectionId: ",sectionId)  
  const table = document.querySelector(
      '#custom-variant-size-content[data-section="' + sectionId + '"]'
    )
  // console.log(table)  
  const trList = table.querySelectorAll('.custom-variant-body-item.show')
  // console.log(trList)
  trList.forEach(function (tr, i) {
    const ele = tr.querySelector('custom-quantity-input')
    // console.log(ele)
    const input = ele.querySelector('input')
    // console.log(input)
    const quantity = input.value
    const currentValue = 1
    const currentMaxValue = Number(input.max)
    // console.log("currentValue: ",currentValue)
    // console.log("currentMaxValue: ",currentMaxValue)
    if (currentMaxValue<=0) {
      currentValue = 0;
    }
    setTimeout(function () {
      input.value = currentValue
      var event = new Event('blur', { bubbles: true });
      input.dispatchEvent(event);
        //currentValue > currentMaxValue ? currentMaxValue : currentValue
    })
  })
}

function unpdateAddCartBtnState(totalNum){
  const cartBtn = document.querySelector('product-form button[name="add"]')
  const addLogo = isNeedLogo()
    
  if(cartBtn){
    let limit_quantity = Number(document.querySelector("custom-variant")?.getAttribute("data-limit-quantity")) || 0;
    let custom_logo_limit_quantity = Number(document.querySelector("custom-variant")?.getAttribute("data-logo-limit-quantity")) || 0;
    cartBtn.dataset.totalQuantity = totalNum;
    if (totalNum) {
      
      if (addLogo) {
        if (totalNum >= custom_logo_limit_quantity) {
          cartBtn.setAttribute("aria-disabled", false);
        }else{
          cartBtn.setAttribute("aria-disabled", true);
        }
      }else if (totalNum >= limit_quantity ) {
        cartBtn.setAttribute("aria-disabled", false);
      }else{
        cartBtn.setAttribute("aria-disabled", true);
      }
    } else {
      cartBtn.setAttribute("aria-disabled", true);
    }
  }
}
 

 
  // 显示弹框
  function showGlobalPopup() {
    const popup = document.getElementById('cart_quantity_limit_modal');
    popup.style.display = 'block';
  }

  // 隐藏弹框
  function hideGlobalPopup() {
    const popup = document.getElementById('cart_quantity_limit_modal');
    popup.style.display = 'none';
  }

  // 绑定关闭按钮的点击事件
  document.getElementById('cart_limit_close_btn').addEventListener('click', hideGlobalPopup);
 
 
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
 

